//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  CatIcon,
  CatImage,
} from 'counselor-mobile-ui'

import { previewImages } from 'counselor-sdk'

export default {
  components: {
    CatIcon,
    CatImage,
  },

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    infoList () {
      // ls: "辅导猫1班"
      // dept: "辅导猫学院"
      // dorm: ""
      // gender: 2
      // grade: "2020"
      // major: "辅导猫专业（5+3）"
      // photo: "https://wecrestest.campusphere.net/counselor/1019339096624724/attachment/945c432414b94e0480b7fc741c582720.png"
      // userId: "01119060"
      // userName: "罗婷很长的名字很长的名字很长的名字很长"
      // userWid: "565446819528"
      const labelObj = {
        photoLabel: '• 照片：',
        userNameLabel: '• 姓名：',
        userIdLabel: '• 学号：',
        genderLabel: '• 性别：',
        gradeLabel: '• 年级：',
        deptLabel: '• 学院：',
        majorLabel: '• 专业：',
        clsLabel: '• 班级：',
        dormLabel: '• 宿舍： ',
      }
      const arr = [
        'photo',
        'userName',
        'userId',
        'gender',
        'grade',
        'dept',
        'major',
        'cls',
        'dorm',
      ]
      const list = []

      arr.forEach((key) => {
        let value = ''

        if (key === 'gender') {
          value = this.info[key] === 2 ? '女' : '男'
        } else {
          value = this.info[key] || '-'
        }

        list.push({
          label: labelObj[`${key}Label`],
          value,
          key,
        })
      })

      return list
    },
  },

  methods: {
    close () {
      this.$emit('close')
    },

    preview (url, Index = 0) {
      const imageLists = [
        {
          type: '1',
          url,
        },
      ]

      previewImages({
        imageLists,
        currentIndex: Index,
        disableUrlCodec: true
      })
    },
  },
}
